<section class="www-tra-cat">
  <p class="www-tra-cat__tit">SPRAWDŹ NASZE SZKOLENIA I ZAREZERWUJ SOBIE MIEJSCE!</p>
  <p class="www-tra-cat__sub">Wybierz kategorię szkolenia i zobacz, co dla Ciebie przygotowaliśmy.</p>
  @if (categoriesByBrand().length) {
    <div class="www-tra-cat__blo d-none d-md-flex" [appAnimate]="'landing'" [speed]="'faster'">
      @for (c of categoriesByBrand(); track $index) {
        <a
          class="www-tra-cat__blo__ite"
          [ngClass]="{
            active: activeCategory() === c.categoryId,
            list: c?.subCategories?.length,
          }"
        >
          <span (click)="changeCategory(c.categoryId)"
            >{{ c.categoryName }}
            @if (c.subCategories?.length) {
              <img class="arr arr-white" src="assets/images/arrow-ios-forward-outline-white.svg" />
              <img class="arr arr-black" src="assets/images/icon-ionic-ios-arrow-round-forward.svg" />
            }
          </span>

          @if (c.subCategories?.length) {
            <div class="www-tra-cat__blo__ite__sub" [appAnimate]="'landing'" [speed]="'faster'">
              @for (sc of c.subCategories; track $index) {
                <div
                  class="www-tra-cat__blo__ite__sub__cat"
                  [ngClass]="{ active: activeSubCategory() === sc.id }"
                  (click)="checkSubCategory(sc.id, c.categoryId)"
                >
                  {{ sc.name }}
                  <img class="arr-check" src="assets/images/arrow-ios-forward-outline-white.svg" />
                </div>
              }
            </div>
          }
        </a>
      }
    </div>
  }
</section>
